import request from '@/config/axios'

export const getBannerList = () => request.get({ url: '/rental/home/banner/list' })
export const getBanner = (id: number) => request.get({ url: '/rental/home/banner/get', params: { id } })
export const createBanner = (data: any) => request.post({ url: '/rental/home/banner/create', data })
export const updateBanner = (data: any) => request.put({ url: '/rental/home/banner/update', data })
export const deleteBanner = (id: number) => request.delete({ url: '/rental/home/banner/delete', params: { id } })
